import $ from 'jquery';
/* eslint-disable max-len */

const accordions = {
  settings: {
    items: null,
  },
  init() {
    this.initAccordions();
  },
  initAccordions: () => {
    accordions.settings.items = document.querySelectorAll('.accordion-item__title');

    accordions.settings.items.forEach((item) => {
      item.addEventListener('click', () => {
        if (item.classList.contains('active')) {
          $(item.nextElementSibling).slideUp();
          item.classList.remove('active');
        } else {
          $(item.nextElementSibling).slideDown();
          item.classList.add('active');
        }
      });
    });

    document.querySelectorAll('.accordion-item').forEach((el) => {
      const iframes = el.querySelectorAll('iframe');
      iframes.forEach((iframe) => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('accordion-item__iframe-wrapper');
        iframe.parentNode.insertBefore(wrapper, iframe);
        wrapper.appendChild(iframe);
      });
    });
  },

};

export default accordions;
accordions.init();
